import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { SOCIALS_ENTITIES } from '../types';
import { setError } from '../../Error';
import ACTIONS from '../constants';
export function setSubscription(entityType, id, status) {
  return {
    type: 'SET_SUBSCRIPTION',
    entityType: entityType,
    id: id,
    status: status
  };
}
export function setLike(entityType, id, status) {
  return {
    type: 'SET_LIKE',
    entityType: entityType,
    id: id,
    status: status
  };
}
export function setSubscriptions(subscriptions, likes, entities) {
  return {
    type: 'SET_SUBSCRIPTIONS',
    subscriptions: subscriptions,
    likes: likes,
    entities: entities
  };
}
export function setProfiles(profiles) {
  return {
    type: 'SET_PROFILES',
    profiles: profiles
  };
}
export function setTags(tags) {
  return {
    type: ACTIONS.SET_USER_TAGS,
    tags: tags
  };
}
export function setFavoritesFetchingStatus(fetching) {
  return {
    type: 'SET_FAVORITES_FETCHING_STATUS',
    fetching: fetching
  };
}
export function setFavorites(favorites) {
  return {
    type: 'SET_FAVORITES',
    favorites: favorites
  };
}
export function setSubscriptionsFetchingStatus(fetching) {
  return {
    type: 'SET_SUBSCRIPTIONS_FETCHING_STATUS',
    fetching: fetching
  };
}
export function setSubscriptionsFetchingEntities(entities, fetching) {
  return {
    type: 'SET_SUBSCRIPTIONS_FETCHING_ENTITIES',
    entities: entities,
    fetching: fetching
  };
}
export function getSubscription(entityType, id, cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/subscriptions/".concat(entityType, "/").concat(id),
      credentials: cookie,
      method: 'GET',
      onSuccess: function onSuccess(_ref) {
        var data = _ref.data;
        return dispatch(setSubscription(entityType, id, data.me === 'subscribed'));
      },
      onError: function onError() {
        return dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}
export function getSubscriptions(cookie) {
  var entities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SOCIALS_ENTITIES;
  var ignoreNeeded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    var fetchingSocialsEntities = getState().user.fetchingSocialsEntities;
    var needed = entities.filter(function (item) {
      return !fetchingSocialsEntities.includes(item);
    });
    var requestedIsFetching = entities.filter(function (item) {
      return fetchingSocialsEntities.includes(item);
    });
    if ((needed.length || ignoreNeeded) && !requestedIsFetching.length) {
      dispatch(setSubscriptionsFetchingEntities(needed, true));
      return finectAPI({
        version: 'v4',
        path: "users/me/socials".concat(needed.length !== 0 ? "?type=".concat(needed.map(function (item) {
          return item.slice(0, -1);
        }).join(',')) : ''),
        credentials: cookie,
        method: 'GET',
        onSuccess: function onSuccess(_ref2) {
          var data = _ref2.data;
          return dispatch(setSubscriptions(data.subscriptions, data.likes, needed));
        },
        onError: function onError() {
          return dispatch(setError({
            code: 404,
            message: 'Error'
          }));
        }
      }).finally(function () {
        return dispatch(setSubscriptionsFetchingEntities(needed, false));
      });
    }
  };
}
export function getProfiles(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/subscriptions?type=profile",
      credentials: cookie,
      method: 'GET',
      onSuccess: function onSuccess(_ref3) {
        var data = _ref3.data;
        return dispatch(setProfiles(data));
      },
      onError: function onError() {
        return dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}
export function getTags(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/subscriptions?type=tag",
      credentials: cookie,
      method: 'GET',
      onSuccess: function onSuccess(_ref4) {
        var data = _ref4.data;
        return dispatch(setTags(data));
      },
      onError: function onError() {
        return dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}
export function getFavorites(cookie) {
  return function (dispatch) {
    dispatch(setFavoritesFetchingStatus(true));
    finectAPI({
      version: 'v4',
      path: "users/me/subscriptions?type=product",
      credentials: cookie,
      method: 'GET',
      onSuccess: function onSuccess(_ref5) {
        var data = _ref5.data;
        dispatch(setFavorites(data));
        dispatch(setFavoritesFetchingStatus(false));
      },
      onError: function onError() {
        return dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}
export function fetchSubscription(entityType, id, status, cookie) {
  if (status) {
    return function (dispatch) {
      dispatch(setSubscriptionsFetchingStatus(true));
      return finectAPI({
        version: 'v4',
        path: "users/me/subscriptions",
        credentials: cookie,
        method: 'POST',
        body: {
          type: entityType,
          id: id
        },
        onSuccess: function onSuccess(_ref6) {
          var data = _ref6.data,
            code = _ref6.code;
          dispatch(setSubscriptionsFetchingStatus(false));
          return {
            code: 200
          };
        },
        onError: function onError(error) {
          dispatch(setSubscriptionsFetchingStatus(false));
          dispatch(setError({
            code: 404,
            message: 'Error'
          }));
          return {
            code: error.status
          };
        }
      });
    };
  }
  return function (dispatch) {
    dispatch(setSubscriptionsFetchingStatus(true));
    finectAPI({
      version: 'v4',
      path: "users/me/subscriptions?type=".concat(entityType, "&id=").concat(id),
      credentials: cookie,
      method: 'DELETE',
      onSuccess: function onSuccess(_ref7) {
        var data = _ref7.data,
          code = _ref7.code;
        dispatch(setSubscriptionsFetchingStatus(false));
      },
      onError: function onError() {
        dispatch(setSubscriptionsFetchingStatus(false));
        dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}
export function fetchLike(entityType, id, status, cookie) {
  if (status) {
    return function (dispatch) {
      dispatch(setSubscriptionsFetchingStatus(true));
      return finectAPI({
        version: 'v4',
        path: "users/me/likes",
        credentials: cookie,
        method: 'POST',
        body: {
          type: entityType,
          id: id
        },
        onSuccess: function onSuccess(_ref8) {
          var data = _ref8.data,
            code = _ref8.code;
          dispatch(setSubscriptionsFetchingStatus(false));
          return {
            code: 200
          };
        },
        onError: function onError(error) {
          dispatch(setSubscriptionsFetchingStatus(false));
          dispatch(setError({
            code: 404,
            message: 'Error'
          }));
          return {
            code: error.status
          };
        }
      });
    };
  }
  return function (dispatch) {
    dispatch(setSubscriptionsFetchingStatus(true));
    finectAPI({
      version: 'v4',
      path: "users/me/likes?type=".concat(entityType, "&id=").concat(id),
      credentials: cookie,
      method: 'DELETE',
      onSuccess: function onSuccess(_ref9) {
        var data = _ref9.data,
          code = _ref9.code;
        dispatch(setSubscriptionsFetchingStatus(false));
      },
      onError: function onError() {
        dispatch(setSubscriptionsFetchingStatus(false));
        dispatch(setError({
          code: 404,
          message: 'Error'
        }));
      }
    });
  };
}